import map from 'lodash/map'
import { WorkOrderStatus } from '@ztechapps/work-order.common'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

const Statuses = map(WorkOrderStatus, (e) => {
  return e.value
})

export const workOrderListFieldConfig: ListFieldConfig = {
  code: { name: 'code', index: 0, size: 150 },
  status: {
    name: 'status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: Statuses,
    },
    index: 1,
    size: 300,
  },
  createdAt: {
    name: 'createdAt',
    displayName: 'Created At',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    index: 2,
    size: 150,
  },

  product: {
    name: 'product.code',
    displayName: 'Product',
    index: 3,
    size: 300,
  },
  quantity: {
    name: 'quantity',
    displayName: 'Quantity',
    index: 4,
    size: 150,
    type: ListFieldTypeEnum.number,
  },

  completionDate: {
    name: 'completionDate',
    displayName: 'Completion Date',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.dateTimeZone,
    index: 5,
    size: 150,
  },

  remarks: { name: 'remarks', index: 6, size: 400 },

  tags: { name: 'tags', isVisible: false },
  _id: { name: '_id', isVisible: false },
  hasParent: {
    name: 'hasParent',
    isVisible: false,
    excludeOnDisplay: true,
    excludeOnSort: true,
    excludeOnSearch: true,
  },
  hasChildren: {
    name: 'hasChildren',
    isVisible: false,
    excludeOnDisplay: true,
    excludeOnSort: true,
    excludeOnSearch: true,
  },
}
